module.exports = __webpack_public_path__ + "img/logo.d6b3e9ca.png";